import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { _GetTiempoTranscurrido } from '../../../utils/Time';

@customElement('app-relative-time')
export class RelativeTime extends LitElement {
    /** Fecha ISO o formato válido */
    @property({ type: String }) k_date: string = '';

    /** Intervalo de actualización en milisegundos
     * @default 60000 (1 minuto) */
    @property({ type: Number }) k_interval: number = 60000; // Default: 1 minuto

    @state() private _now: number = Date.now();
    private _timerInterval?: number;

    static styles = css`
    :host {
        display: inline-block;
    }
`;

    render() {
        return html`<span>${this._formatRelativeTime()}</span>`;
    }

    connectedCallback() {
        super.connectedCallback();
        this._startTimer();
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        this._stopTimer();
    }

    updated(changedProperties: Map<string, any>) {
        if (changedProperties.has('k_interval')) {
            this._restartTimer();
        }
    }

    private _startTimer() {
        if (this._timerInterval) return;
        this._timerInterval = window.setInterval(() => {
            this._now = Date.now();
        }, this.k_interval);
    }

    private _stopTimer() {
        if (!this._timerInterval) return;
        clearInterval(this._timerInterval);
        this._timerInterval = undefined;
    }

    private _restartTimer() {
        this._stopTimer();
        this._startTimer();
    }

    private _formatRelativeTime(): string {
        return _GetTiempoTranscurrido(this.k_date, this._now);
    }
}